import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";

const ActionEtichettaCard = ({
  label,
  iconId,
  onClick,
  className = "",
  disabled = false,
}) => {
  return (
    <div className={`etichetta d-inline-flex align-items-center ${className}`}>
      <button
        type="button"
        className="btn btn-link p-0 d-inline-flex align-items-center text-decoration-none"
        onClick={onClick}
        disabled={disabled}
      >
        <svg className="icon icon-primary mr-1" aria-hidden="true">
          <use href={`${iconSprite}#${iconId}`} />
        </svg>
        <span>{label}</span>
      </button>
    </div>
  );
};

export default ActionEtichettaCard;
